export const pos66zonavedekezes = {
  id: "pos66zonavedekezes",
  name: "Zone defense",
  category: "6 - 6",
  snapshots: [
    {
      players: [
        {
          x: 3.560492493915444,
          y: 6.212026507196461
        },
        {
          x: 11.005518176079937,
          y: 6.17197920458576
        },
        {
          x: 7.182467917530055,
          y: 7.305888733128921
        },
        {
          x: 7.143561724408696,
          y: 3.9866652767860478
        },
        {
          x: 0.7914809177995725,
          y: 3.147329350953461
        },
        {
          x: 13.492332011852925,
          y: 3.242928417210368
        }
      ],
      opponents: [
        {
          x: 12.105978506582755,
          y: 3.9987866983903637
        },
        {
          x: 9.063559018298005,
          y: 4.433389497344497
        },
        {
          x: 7.168703942885678,
          y: 5.5221052636952095
        },
        {
          x: 6.453494510627847,
          y: 3.132750917933748
        },
        {
          x: 4.811227212812454,
          y: 5.011517961107844
        },
        {
          x: 2.17683184588397,
          y: 3.6163210122531178
        }
      ],
      ball: {
        x: 8.10316476400323,
        y: 7.101099558913437
      },
      goalkeepers: [
        {
          x: 6.994288363621939,
          y: 0.9155671223374963
        }
      ]
    }
  ]
}
